import {
	QueryClient,
	HydrationBoundary as ReactQueryHydrationBoundary,
	dehydrate as reactQueryDehydrate,
	isServer as reactQueryIsServer,
	useMutation as useReactMutation,
	useQuery as useReactQuery,
} from '@tanstack/react-query';
import axios from 'axios';

import { HTTPClient } from '../types';

export const createHTTPClient = (/* context: AxiosContext */): HTTPClient => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 5 * 60 * 1000,
				retry: false,
				refetchOnWindowFocus: false,
			},
		},
	});

	const apis = {
		parkingSessionApi: process.env.NEXT_PUBLIC_PARKING_SESSION_API_URL
			? axios.create({
					baseURL: process.env.NEXT_PUBLIC_PARKING_SESSION_API_URL,
					adapter: reactQueryIsServer ? undefined : 'xhr', // Use native fetch on server
					proxy: false,
					headers: {
						Accept: 'application/json',
					},
				})
			: null,
		rateEngineApi: process.env.NEXT_PUBLIC_RATE_ENGINE_API_URL
			? axios.create({
					baseURL: process.env.NEXT_PUBLIC_RATE_ENGINE_API_URL,
					adapter: reactQueryIsServer ? undefined : 'xhr', // Use native fetch on server
					proxy: false,
					headers: {
						Accept: 'application/json',
					},
				})
			: null,
	};

	Object.values(apis).forEach((api) => {
		if (api) {
			api.interceptors.request.use(
				(config) => config,
				(error) => Promise.reject(error),
			);

			api.interceptors.response.use(
				(response) => response,
				(error) => Promise.reject(error),
			);
		}
	});

	return {
		queryClient,
		apis: {
			...(apis?.parkingSessionApi ? { parkingSessionApi: apis.parkingSessionApi } : {}),
			...(apis?.rateEngineApi ? { rateEngineApi: apis.rateEngineApi } : {}),
		},
	};
};

export const dehydrate = reactQueryDehydrate;
export const isServer = reactQueryIsServer;
export const HydrationBoundary = ReactQueryHydrationBoundary;
export const useHTTPQuery = useReactQuery;
export const useHTTPMutation = useReactMutation;
